module.exports = __webpack_public_path__ + "static/media/starggieh.9cb7de35.jpg";